import React from 'react';
import {
  Box,
  Button,
  Flex,
  Text,
  useToast,
  Select,
  Spacer,
  Input,
  Circle,
  Tr,
  Td,
  Tooltip,
  useDisclosure,
} from '@chakra-ui/react';
import {
  listSoftpinCategories,
  colSoftpinCategories,
} from '../../context/data';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import style from '../../components/common/style';
import { ChecktableTwo } from '../../components/common/ChecktableTwo';
import { MiniHeader } from '../../components/common/customComponent';
import LangContext from '../../context/languageContext';
import ApiManager from '../../config/apiManager';
import { options } from '../../context/data';
import { NotAllowedIcon, EditIcon, CheckIcon } from '@chakra-ui/icons';
import Swal from 'sweetalert2'

const SoftpinCategories = () => {
  let history = useHistory();
  const [dataa, setDataa] = React.useState();
  const [loader, setLoader] = React.useState(false);
  const { currentLangData } = React.useContext(LangContext);
  const [value, setValue] = React.useState('10');
  const [success, setSuccess] = React.useState(null);
  const [display, setDisplay] = React.useState(false);
  const [error, setError] = React.useState(null);
  const [paginat, setpaginate] = React.useState();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const cancelRef = React.useRef();
  let tempArray = [];
  const toast = useToast();
  const handleOnChange = (evt, key) => {
    const ev = evt.target.value;
    setValue(ev);
  };
  React.useEffect(() => {
    getALLItems(value, 1);
  }, [value]);

  const getALLItems = (limit, page) => {
    setLoader(false);
    let apimanager = ApiManager.getInstance();
    const body = {
      numRecords: limit,
      page: page,
    };
    apimanager
      .get('getAllSoftpinsCategories', body)
      .then(res => {
        if (res.message === 8208) {
          res?.results?.docs?.map((value, index) => {
            tempArray.push(value);
          });
          setDataa(tempArray);
          setpaginate(res?.results);
          setLoader(true);
        }
        console.log('dataaaa=>>>>>', dataa);
      })
      .catch(error => {
        console.log('error', error);
        setLoader(true);
      });
  };

  const revokeItem = item => {
    Swal.fire({
      title: 'CONFIRMATION !',
      text: "Want to revoke this category?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      confirmButtonText: 'Revoke'
    }).then((result) => {
      if (result.isConfirmed) {
        let apimanager = ApiManager.getInstance();
        const body = {
          id: item?._id,
          status: item?.status,
        };
        console.log('body>>>>', body);
        apimanager
          .post('revokeSoftpinCategory', body)
          .then(response => {
            console.log(response, 'responce2');
            if (response.message === 8207) {
              // setSuccess('Successfully Revoked!');
              toast({
                title: 'Successfully Revoked!',
                status: 'success',
                duration: 3000,
                isClosable: true,
                description: `Revoked, Please processed to List!`,
              });
              getALLItems(value, 1);
            }
          })
          .catch(error => {
            console.log(error);
          });
      }
    })
  };

  const enableItem = item => {
    console.log('enableId', item);
    let apimanager = ApiManager.getInstance();
    const body = {
      id: item?._id,
      status: item?.status,
    };
    console.log('body>>>>', body);
    apimanager
      .post('enableSoftpinCategory', body)
      .then(response => {
        // console.log(response, 'responce3');
        if (response.message === 8652) {
          // setSuccess('Successfully Enable!');
          toast({
            title: 'Successfully Enable!',
            status: 'success',
            duration: 3000,
            isClosable: true,
            description: `Enable, Please processed to List!`,
          });
          getALLItems(value, 1);
        }
      })
      .catch(error => {
        console.log(error);
      });
  };

  return (
    <Flex flexDirection={'column'}>
      <Flex {...style.miniheader}>
        {MiniHeader({
          title: 'Softpin Category list',
          path: 'Dashboard',
          onclickForRoute: () => history.push('/Dashboard'),
          path2: 'Softpin Categories',
        })}
      </Flex>
      <Flex {...style.box} background={'#fafdfb'} padding={10}>
        <Flex {...style.main}>
          <Flex {...style.buttoncontainer}>
            <Button
              {...style.createbutton}
              onClick={() => history.push('/CreateSoftpinCategory')}
            >
              Create
            </Button>
          </Flex>
          <Flex {...style.optionFlex}>
            <Flex {...style.showentries} alignItems={'center'} fontSize={'sm'}>
              <Text>{currentLangData?.app?.show}</Text>
              <Select
                {...style.select}
                // onChange={e => setSelectvalue(e.target.value)}
                onChange={e => handleOnChange(e, 'numrecords')}
              >
                {options.map(option => (
                  <option value={option.value}>{option.label}</option>
                ))}
              </Select>
              <Text>{currentLangData?.app?.entries}</Text>
            </Flex>
            <Spacer />
            {/* <Flex alignItems={'center'} {...style.showentries}>
              <Text paddingY={'5px'}>{currentLangData?.app?.search}:</Text>
              <Input {...style.searchinput}></Input>
            </Flex> */}
          </Flex>
          <ChecktableTwo
            datalist={dataa}
            TotDocs={paginat}
            loaderr={loader}
            headerNames={colSoftpinCategories}
            onPageChange={page => getALLItems(value, page)}
            renderItem={({ item, index }) => {
              console.log('renderitem', item);
              return (
                <Tr key={index} width={'100%'}>
                  <Td>
                    <Flex flexDirection={'row'} textAlign={'center'}>
                      <Flex mt={0.5} mr={2}>
                        {item?.name}
                      </Flex>
                      {item?.status === 1 ? (
                        <Circle
                          paddingY={'2px'}
                          paddingX={'10px'}
                          bg="red.300"
                          color="white"
                        >
                          <Text fontSize={'12px'}>
                            {currentLangData?.app?.revoke}
                          </Text>
                        </Circle>
                      ) : null}
                    </Flex>
                  </Td>
                  <Td>{item?.price}</Td>
                  <Td>{item?.amount}</Td>

                  <Td
                    position={'relative'}
                    display={'inline-flex'}
                    verticalAlign={'middle'}
                  >
                    <Tooltip label={currentLangData?.app?.edit}>
                      <Button
                        {...style.editbtn}
                        leftIcon={<EditIcon />}
                        onClick={() =>
                          history.push({
                            pathname: '/CreateSoftpinCategory',
                            status: 'create',
                            state: { val: item, edit: true },
                          })
                        }
                      ></Button>
                    </Tooltip>
                    {item?.status === 1 ? (
                      <Tooltip
                        label={currentLangData?.app?.active}
                        bg={'Green'}
                      >
                        <Button
                          {...style.activebtn}
                          leftIcon={<CheckIcon />}
                          onClick={() => enableItem(item)}
                        ></Button>
                      </Tooltip>
                    ) : item?.status === 0 ? (
                      <Tooltip label={currentLangData?.app?.revoke} bg={'red'}>
                        <Button
                          {...style.Delbtn}
                          leftIcon={<NotAllowedIcon />}
                          onClick={() => revokeItem(item)}
                          // ml={3}
                        >
                        </Button>
                      </Tooltip>
                    ) : 
                    null}
                  </Td>
                </Tr>
              );
            }}
          />
        </Flex>
      </Flex>
    </Flex>
  );
};
export default SoftpinCategories;